// extracted by mini-css-extract-plugin
export var boldText = "_2r-4";
export var checkboxContainer = "_2r-6";
export var closeIcon = "_2r-g";
export var container = "_2r-0";
export var drawer = "_2r-8";
export var drawerContent = "_2r-9";
export var extraSmallText = "_2r-5";
export var fulfillmentGroupTable = "_2r-e";
export var largeText = "_2r-3";
export var loadingSpinnerContainer = "_2r-h";
export var mediumText = "_2r-2";
export var narrow = "_2r-f";
export var notificationLink = "_2r-j";
export var packageCheckIconContainer = "_2r-7";
export var slideoutHeaderContainer = "_2r-a";
export var slideoutModal = "_2r-c";
export var stickyHeaderWrapper = "_2r-b";
export var table = "_2r-i";
export var tableContainer = "_2r-d";
export var tertiaryText = "_2r-1";